module.exports = __webpack_public_path__ + "static/media/FD5.404d4817.png";